import { mergeProps, useFocusRing } from 'react-aria';

import { useOptionContext } from '../../list-box/ListBox';
import { ListItem } from '../../list-box/ListItem';

import { useZone } from '../../../store/zones/useZones.ts';

import { theme } from '../../../theme/theme';

export function OptionZone(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, option, state, item, value } = useOptionContext();

  const focusRing = useFocusRing();

  const { zone } = useZone({ zoneId: item.key });

  return (
    <ListItem.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      className={props.className}
      style={{ '--indent-level': value.level }}
      as={props.as}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <ListItem.Inner>
        <ListItem.Icon
          source={value.icon}
          size={theme.icon.size_default}
          color={`var(--module-glyph-color)`}
        />

        <ListItem.Name>{zone?.name}</ListItem.Name>
      </ListItem.Inner>
    </ListItem.Root>
  );
}
